export const authApi = {
  async login(email, password) {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email, password }),
    });

    if (!res.ok) throw new Error("Credenciais inválidas");

    return res.json(); // { user, accessToken }
  },

  async sso(token) {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sso`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ token }),
    });

    if (!res.ok) throw new Error("Credenciais inválidas");

    return res.json();
  },

  async refresh() {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/refresh`, {
      method: "POST",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Falha no refresh");

    return res.json(); // { user, accessToken }
  },

  async logout() {
    return fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
  },
};
